var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tab-layout',[_c('cart',{staticClass:"tab-pane col-12 col-xl-9 px-0 show active",attrs:{"slot":"tabContent","cartMembers":_vm.cartMembers,"nominate":_vm.nominate,"id":"cart","role":"tabpanel","aria-label":"Cart"},on:{"cartChanged":function($event){return _vm.cartChanged()}},slot:"tabContent"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66abf744","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Horses/Cart/Cart.vue
// module id = 925
// module chunks = 30